// For Firebase JS SDK v7.20.0 and later, measurementId is optional
import firebase from "firebase";

const firebaseConfig = {
    apiKey: "AIzaSyAyYUEOuQjs9FjkyopJdynywvS47BxTlK8",
    authDomain: "medical-70178.firebaseapp.com",
    databaseURL: "https://medical-70178.firebaseio.com",
    projectId: "medical-70178",
    storageBucket: "medical-70178.appspot.com",
    messagingSenderId: "798888722907",
    appId: "1:798888722907:web:4ffee6d692ef4c85f8e7fe",
    measurementId: "G-QFBFCTG1RL"
  };

  const firebaseApp= firebase.initializeApp(firebaseConfig);
  const db = firebaseApp.firestore();
  const auth = firebase.auth();

  export {db,auth};